import styled from 'styled-components'
import { getConnectionNodes } from 'utils/api'

import Spinner from 'components/display/Spinner'
import Review, { ReviewWrapper } from '../Review'

const ReviewListWrapper = styled.div`
  > div {
    margin-bottom: 16px;
  }
`
const ReviewPlaceholder = styled(ReviewWrapper)`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 40px;
`

interface ReviewListProps {
  loading?: boolean
  reviewsConnection: GQL_ListingReviewFragment[]
  condensed?: boolean
}

const ReviewList = ({
  loading,
  reviewsConnection,
  condensed,
}: ReviewListProps) => (
  <ReviewListWrapper>
    {loading && (
      <ReviewPlaceholder>
        <Spinner />
      </ReviewPlaceholder>
    )}

    {!loading &&
      getConnectionNodes(reviewsConnection).map((review) => (
        <Review key={review.id} review={review} condensed={condensed} />
      ))}
  </ReviewListWrapper>
)

export default ReviewList
